// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PostMenu__item--admin":"qo_a","PostMenu__item--moderator":"qo_b","PostMenu__item--author":"qo_c"};